<template>
	<Layout :pageTitle="'Ingresar'" class="" :hideNavbar="true" :hideFooter="true">
		<div class="container">
			<div class="card">
				<div class="card-body">
					<router-link tag="a" to="/">
						<img src="https://cobraticket.uy/logo.svg" alt="" class="logo" />
					</router-link>
					<h3 class="mt-3">Ingresar a CobraTicket</h3>
					<Login :redirectTo="redirectTo" />
				</div>
			</div>
		</div>
	</Layout>
</template>

<script>
import Layout from "@/components/Layout"
import Login from "./Login"

export default {
	name: "loginPage",
	components: {
		Layout,
		Login
	},
	data() {
		return {
			redirectTo: this.$route.query.redirectTo || null
		}
	},
	beforeMount() {
		console.log("mount login")
	}
}
</script>

<style scoped lang="scss">
.container {
	min-height: 100vh;
	display: flex;
	align-items: center;
	justify-content: center;

	.card {
		width: 414px;
		text-align: center;
		padding-top: 32px;
		padding-bottom: 32px;

		.card-body {
			width: 100%;
			max-width: 85%;
			padding: 0px;
			margin: auto;

			h3 {
				font-size: 1.4rem;
			}
			.logo {
				width: 200px;
				margin-top: 30px;
				margin-bottom: 30px;
			}
		}
	}
}
@media (min-width: 1200px) {
	.login-bg {
		background-size: auto;
		background-position: right;
		background-repeat: no-repeat;
	}
}
</style>
